// @ts-nocheck
import {
  CREATE_ADMIN_FAILURE,
  CREATE_ADMIN_REQUEST,
  CREATE_ADMIN_SUCCESS,
  DELETE_ADMIN_FAILURE,
  DELETE_ADMIN_REQUEST,
  DELETE_ADMIN_SUCCESS,
  FETCH_ALL_ADMIN_FAILURE,
  FETCH_ALL_ADMIN_REQUEST,
  FETCH_ALL_ADMIN_SUCCESS,
  SEARCH_ADMIN_FAILURE,
  SEARCH_ADMIN_REQUEST,
  SEARCH_ADMIN_SUCCESS,
  TOGGLE_ADMIN_STATUS_FAILURE,
  TOGGLE_ADMIN_STATUS_REQUEST,
  TOGGLE_ADMIN_STATUS_SUCCESS,
  UPDATE_ADMIN_FAILURE,
  UPDATE_ADMIN_REQUEST,
  UPDATE_ADMIN_SUCCESS,
} from "../constants/admin";

const initialState = {
  admins: [],
  searchString: "",
  isLoading: false,
  statusLoader: false,
  totalPages: 0,
  currentPage: 1,
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    // fetch all admins
    case FETCH_ALL_ADMIN_REQUEST:
      return {
        ...state,
        searchString: action.payload,
        isLoading: true,
      };
    case FETCH_ALL_ADMIN_SUCCESS:
      return {
        ...state,
        admins: action?.payload?.data,
        isLoading: false,
        totalPages: action?.payload?.meta?.totalPages,
        currentPage: action?.payload?.meta?.currentPage,
      };
    case FETCH_ALL_ADMIN_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // create an admin
    case CREATE_ADMIN_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case CREATE_ADMIN_SUCCESS:
      return {
        admins: [
          { ...action?.payload, _id: action?.payload?.id },
          ...state.admins,
        ],
        isLoading: false,
      };
    case CREATE_ADMIN_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // update an admin
    case UPDATE_ADMIN_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UPDATE_ADMIN_SUCCESS:
      return {
        admins: state.admins.map((admin) => {
          if (
            admin?.id === action.payload?._id ||
            admin?._id === action.payload?._id
          ) {
            return { ...action.payload, _id: action.payload?._id };
          }
          return admin;
        }),
        isLoading: false,
      };
    case UPDATE_ADMIN_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // delete an admin
    case DELETE_ADMIN_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case DELETE_ADMIN_SUCCESS:
      return {
        admins: state.admins.filter((admin) => {
          return admin._id !== action.payload;
        }),
        isLoading: false,
      };
    case DELETE_ADMIN_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // toggle admin status
    case TOGGLE_ADMIN_STATUS_REQUEST:
      return {
        ...state,
        statusLoader: true,
      };
    case TOGGLE_ADMIN_STATUS_SUCCESS:
      return {
        ...state,
        admins: state.admins.map((admin) => {
          if (admin?._id === action.payload?._id) {
            return {
              ...action.payload,
              _id: action.payload?._id || action.payload?.id,
              isActive: !admin?.isActive,
            };
          }
          return admin;
        }),
        statusLoader: false,
      };
    case TOGGLE_ADMIN_STATUS_FAILURE:
      return {
        ...state,
        statusLoader: false,
      };

    //search admin
    case SEARCH_ADMIN_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case SEARCH_ADMIN_SUCCESS:
      return {
        ...state,
        admins: action?.payload?.data,
        isLoading: false,
        totalPages: action?.payload?.meta?.totalpages,
        currentPage: action?.payload?.meta?.currentPage,
      };
    case SEARCH_ADMIN_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // defulat
    default:
      return state;
  }
};

export default adminReducer;
export {
  initialState
};